import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import BatchRecordsDetail from './BatchRecordsDetail';
import { loadBatchById } from '../../../redux/batch/actions';
import { BatchDetailsContext } from './BatchDetailsContext';

const ConnectedBatchDetail = () => {
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector(state => state.batch);
  const { id } = useParams();

  const getData = useCallback(() => {
    dispatch(loadBatchById(id));
  }, [dispatch, id]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <BatchDetailsContext.Provider value={getData}>
      <BatchRecordsDetail loadingState={loadingState} reloadAction={getData} data={data} />
    </BatchDetailsContext.Provider>
  );
};

export default ConnectedBatchDetail;
